export default function AboutSection() {
  return (
    <>
      <section id="about" className="py-20 cinematic-bg-light">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {/* Centered section heading */}
          <div className="mb-16 text-center">
            <h2 
              className="text-4xl lg:text-5xl font-bold cinematic-text-dark"
            >
              Guided by&nbsp;Yuliya Yuvati
            </h2>
            <p 
              className="text-xl lg:text-2xl cinematic-text-dark opacity-70 mt-2"
            >
              Mental health &amp; Addiction counseling backed by 10+ years of experience
            </p>
          </div>
          
          {/* Content grid - same height photo and text */}
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <div className="order-2 lg:order-1 flex justify-center">
              <div className="w-full max-w-md h-[600px]">
                <img
                  src="https://static.readdy.ai/image/36990eb3aa57e3c7d396ac7e72f77043/fc07840cd4131dcc9b18636a25ea1f54.jpeg"
                  alt="Yuliya - Art Therapist"
                  className="w-full h-full rounded-2xl shadow-2xl object-cover object-top"
                />
              </div>
            </div>
            
            <div className="order-1 lg:order-2 lg:h-[600px] flex flex-col justify-between">
              <div className="space-y-6 lg:space-y-10 text-base lg:text-xl cinematic-text-dark opacity-80 leading-[1.85] max-w-xl">
                <p>
                  With over a decade of experience in the mental health and addiction recovery field as an addiction counselor and art therapist, I bring a grounded, trauma-informed approach shaped by years of therapeutic work in rehabilitation settings.
                </p>
                
                <p>
                  I have collaborated with two of Southeast Asia's most established rehabilitation centers — <a href="https://seasonsbali.org/" target="_blank" rel="noopener noreferrer" className="text-amber-600 hover:text-amber-700 underline underline-offset-2 transition-colors cursor-pointer">Seasons Bali</a> and <a href="https://www.thecabinchiangmai.com/" target="_blank" rel="noopener noreferrer" className="text-amber-600 hover:text-amber-700 underline underline-offset-2 transition-colors cursor-pointer">The Cabin Chiang Mai</a> — where I developed extensive experience supporting clients through trauma, emotional dysregulation,&nbsp; and addiction recovery.
                </p>
                
                <p>
                  Clients often describe our work as&nbsp;transformative,&nbsp; practical,&nbsp; and deeply supportive. I&nbsp;have received hundreds of&nbsp;positive testimonials, many pointing to&nbsp;lasting improvements in&nbsp;emotional resilience, relationship patterns, self-regulation, and&nbsp;personal confidence.
                </p>
                
                <p>
                  My approach integrates evidence-based therapeutic methods for&nbsp;addiction recovery, art therapy, and&nbsp;a&nbsp;structured emotional framework designed to&nbsp;support meaningful, long-term change — not&nbsp;just temporary relief.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}